import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 7l10 10","key":"svg-0"}],["path",{"d":"M17 8l0 9l-9 0","key":"svg-1"}]]

/**
 * IconArrowDownRight
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctZG93bi1yaWdodCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNyA3bDEwIDEwIiAvPgogIDxwYXRoIGQ9Ik0xNyA4bDAgOWwtOSAwIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/arrow-down-right
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowDownRight = createReactComponent('outline', 'arrow-down-right', 'ArrowDownRight', __iconNode);

export default IconArrowDownRight;